import * as React from 'react';
import {connect} from 'react-redux';
import {createRouteNodeSelector} from 'redux-router5';
import {navigate} from '~/router';
import {parseSaleStatusFilter, saleStatusFilterParams} from '~/apps/pos/shared/services/qsfilter';
import {createStatusHelper} from '~/apps/shared/services/forms';
import {SearchableModelHelper} from '~/lib/forms/select';
import {getSaleStatus, getSaleStatuses} from "~/apps/pos/shared/services/helpers";
import SalesListFilter from "~/apps/pos/mobile/components/sales/SalesListFilter";
import {setSaleCurrentPage} from "~/apps/pos/shared/actions/sales";
import { downloadSaleCSV } from "~/apps/pos/shared/services/sales";


class SalesFilter extends React.Component<any, any> {
  statusHelper: SearchableModelHelper;

  constructor(props) {
    super(props);

    this.statusHelper = createStatusHelper(this.refresh, getSaleStatus, getSaleStatuses);
  }

  refresh = () => {
    this.forceUpdate();
  };

  onExport = (dtStart, dtEnd) => {
    downloadSaleCSV(dtStart, dtEnd);
  }

  render = () => {
    const { route: { params }, hasFhiFeature, dispatch } = this.props;
    const filter = parseSaleStatusFilter(params);

    return (
      <SalesListFilter
        statusHelper={this.statusHelper}
        filter={filter}
        onStatusChange={(statusKey) => {
          filter.status = statusKey;
          navigate('pos.mobile.history', saleStatusFilterParams(filter));
        }}
        onFilter={(q) => {
          filter.q = q;
          navigate('pos.mobile.history', saleStatusFilterParams(filter));
          dispatch(setSaleCurrentPage(0));
        }}
        onExport={hasFhiFeature && this.onExport}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const selector = createRouteNodeSelector('pos.mobile.history');

  return {
    ...selector(state)
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SalesFilter) as any;
